
export default {
  name: 'NoData',
  components: {
  },
  props: {
    type: {
      type: String,
      default: 'normal'
    },
    freeText: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      textInfo: {}
    }
  },
  created () {
    this.setData(this.type)
  },
  methods: {
    reContents (text) {
      return text.split('\n')
    },
    setData (type) {
      const infoItems = {
        // 타입 정리 안 되어 있음
        normal: {
          icon: 'icon-nodata',
          titleText: ''
        },
        restock: {
          icon: 'icon-noalarm',
          titleText: '신청 내역이 없습니다',
        },
        alarm: {
          icon: 'icon-noalarm',
          titleText: '알림 내역이 없습니다',
        },
        search1: {
          icon: 'icon-nodata3',
          titleText: '선택한 조건에 맞는 검색결과가 없습니다',
        },
        search2: {
          icon: 'icon-nodata',
          titleText: '검색결과가 없어요',
        },
        search3: {
          titleText: '검색 결과가 없습니다\n다른 키워드로 검색해 보세요',
        },
        search4: {
          icon: 'icon-nodata',
          titleText: '선택한 조건에 맞는 컨텐츠가 없습니다\n필터를 다시 선택해주세요'
        },
        search5: {
          icon: 'icon-nodata',
          titleText: '검색결과가 없어요\n다른 키워드로 검색해보세요',
        },
        cart: {
          icon: 'icon-cart',
          titleText: '장바구니에 담긴 상품이 없습니다',
          buttonText: '쇼핑하러 가기',
        },
        cancle: {
          icon: 'icon-nodata',
          titleText: '취소 신청 내역이 없습니다'
        },
        contents: {
          icon: 'icon-nodata2',
          titleText: '콘텐츠 작성하고\n다이소몰 캐시 최대 500C 받아가세요\n긴 글 작성은 PC에서만 가능합니다',
        },
        coupon: {
          icon: 'icon-coupon',
          titleText: '받을 수 있는 쿠폰이 없습니다',
        },
        giftcard: {
          icon: 'icon-nogiftcard',
          titleText: '판매 중인 상품권이 없어요',
        },
        point: {
          icon: 'icon-point',
          titleText: '보내거나 받은 포인트 선물 내역이 없습니다'
        },
        review: {
          icon: 'icon-nodata2',
          titleText: '리뷰를 기다리고 있어요',
        },
        faq: {
          icon: 'icon-faq',
          titleText: '문의 내역이 없습니다'
        },
        customer: {
          icon: 'icon-nodata',
          titleText: '아직 문의한 적이 없어요\n이전 문의 내역이 필요하시면 고객센터에 문의바랍니다',
        },
        quest: {
          icon: 'icon-nodata',
          titleText: '심사내역이 없습니다'
        },
        scrap: {
          icon: 'icon-nodata',
          titleText: '스크랩한 콘텐츠가 없습니다',
          linkText: '콘텐츠 보러가기',
          path: '/ug/ugm/SCR_UGM_0001',
        },
        temporary: {
          icon: 'icon-nodata',
          titleText: '임시 저장된 글이 없습니다'
        },
        order: {
          icon: 'icon-noorder',
          titleText: '주문내역이 없습니다'
        },
        package: {
          icon: 'icon-nodata',
          titleText: '꾸러미가 비어있어요',
          linkText: '쇼핑하러 가기',
          path: { name: 'ds-fb-id', params: { id: 'C104' } },
        },
        notice: {
          icon: 'icon-content',
          titleText: '등록된 공지사항이 없습니다'
        },
        exhibition: {
          icon: 'icon-list',
          titleText: '운영되는 기획전이 없습니다\n새로운 기획전으로 찾아뵙겠습니다',
        },
        event: {
          icon: 'icon-list',
          titleText: '운영되는 이벤트가 없습니다\n새로운 이벤트로 찾아뵙겠습니다',
        },
        eventResult: {
          icon: 'icon-content',
          titleText: '이벤트에 참여하지 않으셨네요',
          linkText: '진행 중 이벤트 보러가기',
          path: '/ev/evc/SCR_EVC_0001',
        },
        endEvent: {
          icon: 'icon-end',
          titleText: '종료된 이벤트 입니다',
        },
        mission: {
          icon: 'icon-stamp',
          titleText: '진행가능한 미션이 없어요'
        },
        myProduct: {
          icon: 'icon-nodata4',
          titleText: '찜한 상품이 없습니다',
          linkText: '쇼핑하러 가기',
          path: '/ds',
        },
        showProduct: {
          icon: 'icon-nodata4',
          titleText: '최근 본 상품이 없습니다',
          linkText: '쇼핑하러 가기',
          path: '/ds',
        },
        address: {
          icon: 'icon-place',
          titleText: '배송지를 등록하고\n더 편리하게 이용 가능해요'
        },
        store: {
          icon: 'icon-emptyshop',
          titleText: '픽업매장을 등록하고\n더 편리하게 이용 가능해요'
        }
      }
      this.textInfo = infoItems[type]
    }
  }
}
